<template>
  <boxwrap class="user--inner">
  <div class="admin--inner adminParent">
    <div class="tabHolder">
      <button class="tabButton" v-bind:class="{ active: (tab==1) }" @click="setab(1)">Admin</button>
      <button class="tabButton" v-bind:class="{ active: (tab==2) }" @click="setab(2)">Permissions</button>
      <button class="tabButton" v-bind:class="{ active: (tab==3) }" @click="setab(3)">Whitelist</button>
       <button class="tabButton" v-bind:class="{ active: (tab==4) }" @click="setab(4)">Admin Logs</button>
    </div>
    <div class="adminbox" v-if="(tab==1)">
    <toolbar>
      <toolbar-items class="-searchbar">
        
      </toolbar-items>
    </toolbar>
        <h1>Admins&nbsp;<button
          style="height:40px"
          class="btn--create"
          title="add user"
          @click="createRowToggle()"
        >
          <i class="ico--create"></i>
        </button></h1>
        <div class="search-bar__items -filterby-dp">
        <select v-model="filterByStatus">
            <option value="all">all</option>
            <option value="active">active</option>
            <option value="inactive">inactive</option>
            <option value="deleted">deleted</option>
          </select>
          
          <select v-model="filterByKey">
            <option value="all">no filter</option>
            <option value="login_id">login_id</option>
            <option value="login_name">login name</option>
            <option value="level_id">level id</option>
            <!-- option value="ip">ip</option -->
          </select>
          <div class="input-wrap">
            <input placeholder="" v-model="filterKey" />
          </div>
            <div class="dateshit">
              Created At: 
              <date-time-picker
                ref="datetimepickerFrom"
                v-model='adminListDates.dateFrom'
                mode='from'
                :placeholder="dateRange ? 'from' : 'date'"
                :type='dateType'
                :range="dateRange"
                :setMax='adminListDates.dateTo'
              >
              </date-time-picker>

              <date-time-picker
                ref="datetimepickerTo"
                v-model='adminListDates.dateTo'
                mode='to'
                placeholder='to'
                :type='dateType'
                :range='dateRange'
                :setMin='adminListDates.datFrom'
              >
               </date-time-picker>
            </div>
          <button style="height:40px"  @click="searchAdmin()" class="btn--search">
            <i class="ico--search"></i>
          </button>
          
          <button style="height:40px"  @click="clearAdminList()" class="btn--refresh">
            <i class="ico--refresh"></i>
          </button>
          
       
       
          
          
        </div>

        <table v-if="(admins.length && !currentAdminKey.id && !createFlag )">
        <thead>
          <tr>
            <th @click="fnSort('id')"><span v-if="(sortBy =='id')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> ID</th>
            <th @click="fnSort('login_id')"><span v-if="(sortBy =='login_id')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> Login ID</th>
            <th @click="fnSort('login_name')"><span v-if="(sortBy =='login_name')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> Login Name</th>
            <th @click="fnSort('active')"><span v-if="(sortBy =='active')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> Status</th>
            <th @click="fnSort('level_id')"><span v-if="(sortBy =='level_id')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> Level ID</th>
            <th @click="fnSort('created_at')"><span v-if="(sortBy =='created_at')">{{ ((sort == 'asc')?'&#94;':'v' )}}</span> Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tr v-for="admin in admins" :key="admin.id">
          <td>{{admin.id}}</td>
          <td>{{admin.login_id}}</td>
          <td>{{admin.login_name}}</td>
          <td>{{admin.active}}</td>
          <td>{{admin.level_id}}</td>
          <td>{{admin.created_at}}</td>
          <td>
            
         
          <button style="height:40px"
          class="btn--delete"
          title="delete"
          @click="deleteRow(admin)"
        >
          <i class="ico--delete"></i>
        </button> &nbsp;
        <button style="height:40px"
            class="btn--tbl-modify"
            @click="editRowToggle(admin)"
          >
            <i class="ico--modify"></i>
          </button>
          <!-- a @click.prevent="editRowToggle(admin)" href="#">Edit</a> / <a @click.prevent="deleteRow(admin)" href="#">Delete</a --></td>
        </tr>
        </table>
     <div class="editBox " v-if="currentAdminKey.id">
      <h3>EDITING: {{currentAdminKey.login_name}}</h3>
      <div @click="editRowToggle({},false)">close</div>
      <br />
      <input placeholder="Login Name" v-model="currentAdminKey.login_name" /><br />
      <input placeholder="Level" v-model="currentAdminKey.level_id" /><br />
      Active: <input value="true" type="checkbox" v-model="currentAdminKey.active" />{{currentAdminKey.active}}
      <button @click="editRow(currentAdminKey)" >Save</button>
    </div>
    <div class="editBox" v-if="createFlag">
      <h3>CREATE</h3>
      <div @click="createRowToggle(false)">close</div>
      <br />
      <input placeholder="Login ID" v-model="partialAdminKey.login_id" /><br />
      <input placeholder="Login Name" v-model="partialAdminKey.login_name" /><br />
      <input placeholder="Level" v-model="partialAdminKey.level_id" /><br />
      <input placeholder="Password" v-model="partialAdminKey.password" /><br />
      Active: <input type="checkbox" v-model="partialAdminKey.active" />{{partialAdminKey.active}}
      <br />
      <button @click="createRow(partialAdminKey)" >Save</button>
    </div>
        <pagination :total="count" :limit="row" v-model="page" :rows="row" @page="setPage({page, row, sortBy, sort:'asc', filter, filterBy})"></pagination>
      <div v-if="!admins.length">
        <h1>NO FETCHED DATA!!</h1>
      </div>
    </div>


    
    
    <div class="adminbox" v-else-if="(tab==2)">
      <h1>Permissions</h1>
        <button @click="createPermissionToggle()">Create Permission</button>
        <button @click="deletePermission()">Delete Permission</button>
        <table>
          <thead>
            <tr>
              <th><input type="checkbox" v-model="allSelected" @click="selectAll" /></th>
              <th>Level ID</th>
              <th>Authority</th>
              <th>Permissions</th>
              <th>Permission ID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tr v-for="permission in getPermissions" :key="permission.id">
            <td><input type="checkbox" id="permissionId" :value="permission.id" v-model="checkePermissions" /></td>
            <td>{{permission.level_id}}</td>
            <td>
              <select v-model="permission.authority">
                <option :selected="(!permission.authority) ? 'selected' : ''" value="null">none</option>
                <option :selected="(permission.authority == 'r') ? 'selected' : ''" value="r">Read</option>
                <option :selected="(permission.authority == 'w') ? 'selected' : ''" value="w">Write</option>
                <option :selected="(permission.authority == 'rw') ? 'selected' : ''" value="rw">Read+Write</option>
              </select>
            </td>
            <td>
              <input type="checkbox" v-model="permission.permission.admins" />({{permission.permission.admins}}) Admin
              <input type="checkbox" v-model="permission.permission.banks" />({{permission.permission.banks}}) Banks
              <input type="checkbox" v-model="permission.permission.games" />({{permission.permission.games}}) Games
              <input type="checkbox" v-model="permission.permission.users" />({{permission.permission.users}}) Users
              <input type="checkbox" v-model="permission.permission.domains" />({{permission.permission.domains}}) Domain
              <input type="checkbox" v-model="permission.permission.events" />({{permission.permission.events}}) Events
              <input type="checkbox" v-model="permission.permission.transfers" />({{permission.permission.transfers}}) Transfers
              <input type="checkbox" v-model="permission.permission.bet_history" />({{permission.permission.bet_history}}) Bet history
              <input type="checkbox" v-model="permission.permission.codes" />({{permission.permission.codes}}) Codes
              <input type="checkbox" v-model="permission.permission.ip" />({{permission.permission.ip}}) IP
              <input type="checkbox" v-model="permission.permission.agents" />({{permission.permission.agents}}) Agents
              <input type="checkbox" v-model="permission.permission.supports" />({{permission.permission.supports}}) Supports
              <input type="checkbox" v-model="permission.permission.boards" />({{permission.permission.boards}}) Boards
            </td>
            <td>{{permission.id}}</td>
            <td><a @click.prevent="editPermission(permission.id)" href="#">Save</a></td>
          </tr>
        </table>
        <div class="editBox" v-if="permissionCreateFlag">
          <h3>CREATE</h3>
	  <div @click="createPermissionToggle(false)"> close </div>
          <br />
          permission:
          <div>
              <input type="checkbox" v-model="tempPermission.permission.admins" />({{tempPermission.permission.admins}}) Admin
              <br /><input type="checkbox" v-model="tempPermission.permission.banks" />({{tempPermission.permission.banks}}) Banks
              <br /><input type="checkbox" v-model="tempPermission.permission.games" />({{tempPermission.permission.games}}) Games
              <br /><input type="checkbox" v-model="tempPermission.permission.users" />({{tempPermission.permission.users}}) Users
              <br /><input type="checkbox" v-model="tempPermission.permission.domains" />({{tempPermission.permission.domains}}) Domain
              <br /><input type="checkbox" v-model="tempPermission.permission.events" />({{tempPermission.permission.events}}) Events
              <br /><input type="checkbox" v-model="tempPermission.permission.transfers" />({{tempPermission.permission.transfers}}) Transfers
              <br /><input type="checkbox" v-model="tempPermission.permission.bet_history" />({{tempPermission.permission.bet_history}}) Bet history
              <br /><input type="checkbox" v-model="tempPermission.permission.codes" />({{tempPermission.permission.codes}}) Codes
              <br /><input type="checkbox" v-model="tempPermission.permission.ip" />({{tempPermission.permission.ip}}) IP
              <br /><input type="checkbox" v-model="tempPermission.permission.agents" />({{tempPermission.permission.agents}}) Agents
              <br /><input type="checkbox" v-model="tempPermission.permission.supports" />({{tempPermission.permission.supports}}) Supports
              <br /><input type="checkbox" v-model="tempPermission.permission.boards" />({{tempPermission.permission.boards}}) Boards
          </div>
          <br />
          <input placeholder="Level" v-model="tempPermission.level_id" /><br />
          <button @click="createPermission(tempPermission)" >Save</button>
        </div>
    </div>
    <div class="adminbox" v-else-if="(tab==3)">
      <h1>Whitelist</h1>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>IP</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tr v-for="whitelist in whitelists" :key="whitelist.id">
              <td>{{whitelist.id}}</td>
              <td>{{whitelist.ip}}</td>
              <td>{{whitelist.description}}</td>
              <td><a @click.prevent="editWhitelist(whitelist.ip)" href="#">Remove</a></td>
            </tr>
          </table>
          <button @click="createWhitelistToggle()" >add</button>
          <div class="editBox" v-if="whitelistCreateFlag">
            <h3>ADD IP</h3>
            <div @click="createWhitelistToggle(false)">close</div>
            <br />
            <br/><input placeholder="IP" v-model="tempWhitelist.ip" /><br />
            <br /><input placeholder="Description" v-model="tempWhitelist.description" /><br />
            <button @click="createWhitelist()" >Save</button>
          </div>
    </div>
    <div class="adminbox" v-else-if="(tab==4)">
      <h1>Admin Logs</h1>
          <table>
            <thead>
              <tr>
                <th @click="setLogPage ({sortBy:'admin_logs.id', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.id')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  ID
                </th>
                <th @click="setLogPage ({sortBy:'admins.login_id', isSort:true})">
                  <span v-if="(logParams.sortBy =='admins.login_id')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  admin login ID
                </th>
                <th @click="setLogPage ({sortBy:'admins.login_name', isSort:true})">
                  <span v-if="(logParams.sortBy =='admins.login_name')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  admin login name
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.action', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.action')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  actions
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.pages', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.pages')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  pages
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.origin', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.origin')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  origin
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.origin_id', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.origin_id')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  origin id
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.ip', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.ip')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  ip
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.domain', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.domain')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  domain
                </th>
                <th @click="setLogPage ({sortBy:'admin_logs.creates_at', isSort:true})">
                  <span v-if="(logParams.sortBy =='admin_logs.creates_at')">{{ ((logParams.sort == 'asc')?'&#94;':'v' )}}</span>
                  created at
                </th>
              </tr>
            </thead>
            <tr v-for="l in log" :key="l.id">
              <td>{{l.id}}</td>
              <td>{{l.login_id}}</td>
              <td>{{l.login_name}}</td>
              <td>{{l.action}}</td>
              <td>{{l.pages}}</td>
              <td>{{l.origin}}</td>
              <td>{{l.origin_id}}</td>
              <td>{{l.ip}}</td>
              <td>{{l.domain}}</td>
              <td>{{l.creates_at}}</td>
            </tr>
          </table>
          <pagination v-if="(tab==4)" :total="logParams.count" :limit="logParams.row" v-model="logParams.page" 
          :rows="logParams.row" @page="setLogPage({page:logParams.page, row:logParams.row, sortBy:logParams.sortBy, sort:'asc', filter:logParams.filter, filterBy:logParams.filterBy})"></pagination>
    </div>
  </div>
  </boxwrap>
</template>
<script type="text/javascript">
import { mapState, mapActions, mapGetters } from 'vuex'
import Pagination from '@/components/base/Pagination'
import DateTimePicker from '@/components/base/DateTimePicker'

export default {
  name: 'admin',
  async created () {
    await this.setPage({
      page: this.$router.page || 1,
      row: this.$router.row || 10,
      sortBy: this.$router.sortBy || 'id',
      sort: this.$router.sort || 'asc',
      filter: this.$router.filter || '',
      filterBy: this.$router.filterBy || ''
    })
  },
  components: { Pagination, DateTimePicker },
  data () {
    return {
      page: 1,
      allSelected: false,
      filterByStatus : 'all',
      checkePermissions: [],
      adminListDates : {
        dateTo : '',
      dateFrom: ''
      }
    }
  },
  computed: {
    ...mapState('admin', ['admins',
      'log',
      'count',
      'row',
      'sortBy',
      'sort',
      'logParams',
      'searchKey',
      'filterBy',
      'filter',
      'currentAdmin',
      'partialAdmin',
      'createFlag',
      'whitelists',
      'tempWhitelist',
      'tab',
      'tempPermission',
      'permissionCreateFlag',
      'whitelistCreateFlag']),
    ...mapGetters('admin', ['getPermissions']),
    filterKey: {
      get () {
        return this.filter
      },
      set (value) {
        this.setFilter(value)
      }
    },
    filterByKey: {
      get () {
        return this.filterBy
      },
      set (value) {
        this.setFilterBy(value)
      }
    },
    currentAdminKey: {
      get () {
        return this.currentAdmin
      },
      set (value) {
        this.setCurrentAdmin(value)
      }
    },
    partialAdminKey: {
      get () {
        return this.partialAdmin
      },
      set (value) {
        this.setPartialAdmin(value)
      }
    },
    pageSetter: {
      get () {
        return this.page
      },
      set (value) {
        this.setPage(value)
      }
    },
    permissionKey: {
      get () {
        return this.permissions
      },
      set (value) {
        this.setPermissions(value)
      }
    }
  },
  watch: {
    async filterByStatus (val) {
      await this.setPage({
        stat : val,
        page: this.page,
        row: this.row,
        sortBy: this.sortBy,
        sort: (this.sort === 'asc') ? 'desc' : 'asc',
        filter: this.filter,
        filterBy: this.filterBy
      })
    }
  },
  methods: {
    ...mapActions('admin', { setAdmins: 'set',
      sortAdminLog : 'sortAdminLog',
      setCurrentAdmin: 'setCurrentAdmin',
      setCurrentLog : 'setCurrentLog',
      setPartialAdmin: 'setPartialAdmin',
      setPermissions: 'setPermissions',
      setTempPermission: 'setTempPermission',
      editPermissions: 'editPermissions',
      setFilter: 'setFilter',
      setTab: 'setTab',
      setPage: 'setPage',
      setCreateFlag: 'setCreateFlag',
      setFilterBy: 'setFilterBy',
      search: 'search',
      editAdmin: 'editAdmin',
      createAdmin: 'createAdmin',
      deleteAdmin: 'deleteAdmin',
      createPermissions: 'createPermissions',
      editWhitelist: 'editWhitelist',
      setWhitelistCreateFlag: 'setWhitelistCreateFlag',
      createWhitelist: 'createWhitelist',
      deletePermissions: 'deletePermissions',
      setPermissionCreateFlag: 'setPermissionCreateFlag' }),
    selectAll () {
      var selected = []
      if (!this.allSelected) {
        this.getPermissions.forEach(p => {
          selected.push(p.id)
        })
        this.checkePermissions = selected
      } else {
        this.checkePermissions = []
      }
    },
    async setPage (params) {
      await this.setAdmins(params)
      this.$router.push({ query: params })
    },
    async clearAdminList(){
        
        if(this.filterByStatus !== 'all'){
          this.filterByStatus = 'all'
        }
        this.filterKey = ''
        this.filterByKey = ''
        
 
        
       await this.setPage({
        page: this.$router.page || 1,
        row: this.$router.row || 10,
        sortBy: this.$router.sortBy || 'id',
        sort: this.$router.sort || 'asc',
        filter: this.$router.filter || '',
        filterBy: this.$router.filterBy || ''
      })
      
      this.adminListDates.dateFrom = ''
      this.adminListDates.dateTo = ''
      this.$refs.datetimepickerFrom.reset = true
        this.$refs.datetimepickerTo.reset = true
      
        this.$refs.datetimepickerFrom.resetData()
  

     
        this.$refs.datetimepickerTo.resetData()
     
    },
    async setLogPage (pars,isSort = false) {
      await this.sortAdminLog(pars)
    },
    async fnSort (sortBy) {
      await this.setPage({
        page: this.page,
        row: this.row,
        sortBy: sortBy,
        sort: (this.sort === 'asc') ? 'desc' : 'asc',
        filter: this.filter,
        filterBy: this.filterBy
      })
    },

    async editRowToggle (args, flag = true) {
      this.setCreateFlag(false)
      if(flag) {
        this.setCurrentAdmin(args)
      } else {
        this.setCurrentAdmin({
          active: null,
          created_at: null,
          deleted_at: null,
          id: null,
          level_id: null,
          login_id: null,
          login_name: null,
          password: null
        })
      }
    },
    async createPermission (args) {
      await this.createPermissions(args)
      await this.setPermissionCreateFlag(false)
      await this.setPage({
        page: this.$router.page || 1,
        row: this.$router.row || 10,
        sortBy: this.$router.sortBy || 'id',
        sort: this.$router.sort || 'asc',
        filter: this.$router.filter || '',
        filterBy: this.$router.filterBy || ''
      })
    },
    async createPermissionToggle (flag=true) {
      this.setPermissionCreateFlag(flag)
    },
    async deletePermission () {
      await this.deletePermissions(this.checkePermissions)
    },
    async createWhitelistToggle (flag=true) {
      this.setWhitelistCreateFlag(flag)
    },
    async createRowToggle (flag=true) {
      this.editRowToggle({},false)
      this.setCreateFlag(flag)
    },
    async setab (value) {
      this.setWhitelistCreateFlag(false)
      this.setPermissionCreateFlag(false)
      this.setCreateFlag(false)
      this.editRowToggle({},false)
      this.setTab(value)
    },
    async createRow () {
      await this.createAdmin(this.partialAdmin)
      this.setCreateFlag(false)
      await this.setPage({
        page: this.$router.page || 1,
        row: this.$router.row || 10,
        sortBy: this.$router.sortBy || 'id',
        sort: this.$router.sort || 'asc',
        filter: this.$router.filter || '',
        filterBy: this.$router.filterBy || ''
      })
    },
    async editRow (args) {
      await this.editAdmin(args)
      this.setCurrentAdmin({
        active: null,
        created_at: null,
        deleted_at: null,
        id: null,
        level_id: null,
        login_id: null,
        login_name: null,
        password: null
      })
    },
    async editPermission (id, isDelete = false) {
      await this.editPermissions({ id, isDelete })
      await this.setPage({
        page: this.$router.page || 1,
        row: this.$router.row || 10,
        sortBy: this.$router.sortBy || 'id',
        sort: this.$router.sort || 'asc',
        filter: this.$router.filter || '',
        filterBy: this.$router.filterBy || ''
      })
    },
    async deleteRow (args) {
      await this.deleteAdmin(args)
    },
    async searchAdmin () {
      // if ((!this.filter || !this.filterBy) && (!this.dateFrom)) { return }
      await this.setPage({
        page: this.$router.page || 1,
        row: this.$router.row || 10,
        sortBy: this.$router.sortBy || 'id',
        sort: this.$router.sort || 'asc',
        filter: this.filter || '',
        filterBy: this.filterBy || '',
        dateBy: 'created_at',
        dateFrom: this.adminListDates.dateFrom,
        dateTo: this.adminListDates.dateTo
      })
    }
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.users--inner {
  color: #fff
}
table td, tr {
  // border:1px solid #888;
  padding: 5px;
  margin: 0
}
li {
  list-style: none;
  text-align: left;
  background: #4c4c4c;
  margin-bottom: 2px;
  padding: 4px
}
input, select {
  padding: 9px;
  border: 1px solid #dddddd;
}
button {
  padding: 10px;
  margin-right: 2px
}
.link {
  color:#42b983;
  &:hover {
    cursor: pointer;
    background: #f0f0f0
  }
}
.users__header {
  text-align: left;
}
.users__navigation {
  text-align: left;
}
.users__loading {
  font-size: 30px
}

.users-create__popup {
  position: absolute;
  z-index: 9999;
  top:0;
  right: 0;
  bottom: 0;
  left: 0;
  margin:auto;
  background: rgba(0, 0, 0, 0.8);
  height: auto;
  overflow: auto;
  padding-top: 20px
}

.users-popup__inner {
  margin-top: 20px;
  display: inline-block;
  width: 20%;
}
.users-popup__inner {
  input, select {
    width: 100%
  }
}
.editBox {
  text-align: center;
  padding:10px;
  background:#000;
  width:300px;
  margin:20px auto;
}
.editBox input {
  margin-bottom:2px;
}
.adminbox {
  border-block-start: 1px solid;
  border-block-end: 1px solid;
  padding: 20px;
}
.tabButton {
  background: #2c323c;
  color: #b6ced8;
  border: 1px solid;
  margin-bottom: -1px;
  z-index:10;
}
.active {
  background: none;
}
.adminParent {
  margin: 20px 0px;
}
.tabHolder {
  margin-left: 20px;
}
.adminbox table {
  margin-bottom: 20px;
}
</style>
